/* Wishlist: saved in the shopper's browser (localStorage), so it needs no app or account. Hearts
   ([data-wishlist-toggle="<handle>"]) toggle a product; every heart on the page, in other tabs and in cards loaded
   later stays in step. [data-wishlist-count] shows how many are saved. The wishlist page
   (sections/main-wishlist.liquid) reads LMB.wishlist.handles(). A browser-only list doesn't follow the shopper to
   another device.
   The list in memory is the source of truth for this page; storage is read at start, when another tab changes it and
   when the page comes back from the back/forward cache, so a blocked or full storage still gives working hearts. */
(() => {
  const LMB = (window.LMB = window.LMB || {});
  if (LMB.wishlist) return;

  const KEY = 'lmb:wishlist';
  // The wishlist page shows every saved piece, so this is also the most it loads.
  const MAX = 48;

  const read = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.filter((h) => typeof h === 'string').slice(0, MAX) : [];
    } catch (error) {
      return null;
    }
  };
  const write = () => {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(saved));
    } catch (error) {
      /* storage full or blocked: the list still works on this page */
    }
  };

  let saved = read() || [];
  const refresh = () => {
    const stored = read();
    if (stored) saved = stored;
  };

  const sync = (root = document) => {
    root.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(saved.includes(button.dataset.wishlistToggle)));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = saved.length ? String(saved.length) : '';
      el.hidden = !saved.length;
    });
  };

  const changed = (detail) => {
    write();
    sync();
    document.dispatchEvent(new CustomEvent('lmb:wishlist:change', { detail: { ...detail, handles: saved.slice() } }));
  };

  const toggle = (handle) => {
    const on = !saved.includes(handle);
    saved = on ? [handle, ...saved].slice(0, MAX) : saved.filter((h) => h !== handle);
    changed({ handle, saved: on });
  };

  LMB.wishlist = {
    max: MAX,
    handles: () => saved.slice(),
    has: (handle) => saved.includes(handle),
    toggle,
    remove(handle) {
      if (saved.includes(handle)) toggle(handle);
    },
    // A product's handle changed (Shopify redirected the old URL): keep its place in the list.
    replace(from, to) {
      if (!saved.includes(from) || from === to) return;
      saved = saved.map((h) => (h === from ? to : h)).filter((h, i, list) => list.indexOf(h) === i);
      changed({ handle: to, saved: true });
    },
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    toggle(button.dataset.wishlistToggle);
  });

  // Another tab changed the list.
  window.addEventListener('storage', (event) => {
    if (event.key !== KEY) return;
    refresh();
    sync();
    document.dispatchEvent(new CustomEvent('lmb:wishlist:change', { detail: { handles: saved.slice() } }));
  });

  // Cards added later (tabs, Load more, recommendations, search) get the right state too.
  let pending = false;
  new MutationObserver((records) => {
    if (pending) return;
    if (!records.some((r) => Array.from(r.addedNodes).some((n) => n.nodeType === 1 && (n.matches('[data-wishlist-toggle]') || n.querySelector('[data-wishlist-toggle]'))))) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      sync();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  const start = () => sync();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      refresh();
      sync();
    }
  });
})();
